import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dashboard-theme.css'; // Import our custom dashboard theme
import './pages/page-theme-fixes.css'; // Import specific page fixes
import App from './App';
import reportWebVitals from './reportWebVitals';
import enforceTheme from './utils/themeEnforcer';

// Component to enforce theme and load the app
const ThemedApp: React.FC = () => {
  useEffect(() => {
    // Start the theme enforcer
    const observer = enforceTheme();
    
    // Clean up when the app unmounts
    return () => {
      observer.disconnect();
    };
  }, []);
  
  return <App />;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemedApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
